(function () {
  'use strict';

  var listenersBound = false;

  function getVariantIdFromScope(scope) {
    if (!scope) {
      return null;
    }

    var idInput =
      scope.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      scope.querySelector('select[name="id"]');

    return idInput ? String(idInput.value) : null;
  }

  function getStockLabel(quantity, available) {
    quantity = Number(quantity || 0);

    if (!available || quantity <= 0) {
      return {
        text: 'Brak na stanie',
        className: 'loanti-stock-status--none'
      };
    }

    if (quantity >= 1 && quantity <= 3) {
      return {
        text: 'Ostatnie sztuki',
        className: 'loanti-stock-status--low'
      };
    }

    if (quantity >= 4 && quantity <= 10) {
      return {
        text: 'Dostępne',
        className: 'loanti-stock-status--available'
      };
    }

    if (quantity > 10) {
      return {
        text: 'Duża ilość',
        className: 'loanti-stock-status--high'
      };
    }

    return {
      text: 'Dostępne',
      className: 'loanti-stock-status--available'
    };
  }

  function findMainPriceElement(scope) {
    var selectors = [
      '.product-single__meta .product__price',
      '.product-single__meta .price',
      '.product__info-wrapper .product__price',
      '.product__info-wrapper .price',
      '.product__price',
      '.price'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var elements = scope.querySelectorAll(selectors[i]);

      for (var j = 0; j < elements.length; j++) {
        var el = elements[j];
        var rect = el.getBoundingClientRect();

        if (rect.width > 0 && rect.height > 0 && el.textContent.trim().length > 0) {
          return el;
        }
      }
    }

    return null;
  }

  function getStockScope(wrapper) {
    return (
      wrapper.closest('.product-section, .modal--quick-shop, [data-product-blocks], .product-single__meta') ||
      wrapper.parentElement ||
      document
    );
  }

  function findStockJson(wrapper, scope) {
    var jsonEl = null;

    if (wrapper.parentElement) {
      jsonEl = wrapper.parentElement.querySelector('[data-loanti-variant-stock-json]');
    }

    if (!jsonEl && scope) {
      jsonEl = scope.querySelector('[data-loanti-variant-stock-json]');
    }

    return jsonEl;
  }

  function moveStockNextToPrice(wrapper, scope) {
    if (!wrapper || wrapper.closest('.loanti-price-stock-row')) {
      return;
    }

    var price = findMainPriceElement(scope);

    if (!price) {
      return;
    }

    if (scope.contains && !scope.contains(price)) {
      return;
    }

    if (scope.querySelector && scope.querySelector('.loanti-price-stock-row')) {
      return;
    }

    var row = document.createElement('div');
    row.className = 'loanti-price-stock-row';

    price.parentNode.insertBefore(row, price);
    row.appendChild(price);
    row.appendChild(wrapper);
  }

  function updateSingleStockStatus(wrapper) {
    var text = wrapper.querySelector('[data-stock-text]');
    var scope = getStockScope(wrapper);
    var jsonEl = findStockJson(wrapper, scope);

    if (!text || !jsonEl) {
      return;
    }

    var stockData = {};

    try {
      stockData = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var variantId = getVariantIdFromScope(scope);

    if (!variantId || !stockData[variantId]) {
      variantId = Object.keys(stockData)[0];
    }

    var variant = stockData[variantId];

    if (!variant) {
      return;
    }

    var result = getStockLabel(variant.quantity, variant.available);

    wrapper.classList.remove(
      'loanti-stock-status--none',
      'loanti-stock-status--low',
      'loanti-stock-status--available',
      'loanti-stock-status--high'
    );

    wrapper.classList.add(result.className);
    text.textContent = result.text;
  }

  function updateAllStockStatuses(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-loanti-stock-status]').forEach(updateSingleStockStatus);
  }

  function bindGlobalListeners() {
    if (listenersBound) {
      return;
    }

    listenersBound = true;

    document.addEventListener('change', function (event) {
      if (
        event.target.matches('input[name="id"]') ||
        event.target.matches('select[name="id"]') ||
        event.target.matches('input[type="radio"]') ||
        event.target.matches('select')
      ) {
        window.setTimeout(function () {
          updateAllStockStatuses();
        }, 80);
        window.setTimeout(function () {
          updateAllStockStatuses();
        }, 250);
      }
    });

    document.addEventListener('click', function () {
      window.setTimeout(function () {
        updateAllStockStatuses();
      }, 120);
    });

    document.addEventListener('quickview:loaded', function () {
      window.LoantiStockStatusInit();
    });

    document.addEventListener('quickview:open', function () {
      window.LoantiStockStatusInit();
    });
  }

  window.LoantiStockStatusInit = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-loanti-stock-status]').forEach(function (wrapper) {
      var containerScope = getStockScope(wrapper);
      moveStockNextToPrice(wrapper, containerScope);
      updateSingleStockStatus(wrapper);
    });

    bindGlobalListeners();
  };

  function onReady() {
    window.LoantiStockStatusInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
